import { faker } from '@faker-js/faker';
import { HttpResponse, delay, http } from 'msw';

import { getPlatformGetLocalUserResponseMock } from 'shared/base';

import { getCustomHandlerLoginStatus, getCustomHandlerMembership } from './utils';
import { MOCK_DELAY } from './utils/constants';

export const getCustomPlatformGetLocalUserMockHandler = () => {
  return http.get('*/manage/users/:userId', async () => {
    await delay(MOCK_DELAY);

    if (!getCustomHandlerLoginStatus()) {
      return new HttpResponse(null, { status: 401 });
    }

    const membership = getCustomHandlerMembership();

    return HttpResponse.json(
      {
        ...getPlatformGetLocalUserResponseMock(),
        created_at: `${faker.date.past().toISOString().split('.')[0]}Z`,
        email: 'admin@localhost',
        enabled: true,
        is_admin: true,
        name: 'Admin',
        teams: membership
          ? [
              {
                created_at: `${faker.date.past().toISOString().split('.')[0]}Z`,
                roles: ['admin:write'],
                team_name: membership.team.name,
                updated_at: `${faker.date.past().toISOString().split('.')[0]}Z`,
              },
            ]
          : [],
        updated_at: faker.helpers.arrayElement([
          `${faker.date.past().toISOString().split('.')[0]}Z`,
          undefined,
        ]),
      },
      {
        status: 200,
      },
    );
  });
};
